import { LoadingButton } from '@mui/lab'
import { Button, Stack } from '@mui/material'
import React from 'react'

import Icon from 'components/Icon'
import {
  CreateTestSuiteFormViewName,
  CreateTestSuiteFormViewItem
} from 'components/test-suites/forms/test-suite-form-utils'

export const CreateTestSuiteFormButtons: React.FC<{
  activeView: CreateTestSuiteFormViewItem
  handleBack: () => void
  handleNext: (e: React.MouseEvent<HTMLButtonElement>) => void
  isSaving: boolean
  shouldShowWarning: boolean
}> = ({ activeView, handleBack, handleNext, isSaving, shouldShowWarning }) => {
  return (
    <Stack direction="row" py={4} spacing={2}>
      {activeView.secondaryButtonText && (
        <Button
          variant="contained"
          onClick={handleBack}
          {...(activeView.secondaryStartIcon
            ? { startIcon: activeView.secondaryStartIcon }
            : {})}
        >
          {activeView.secondaryButtonText}
        </Button>
      )}
      {activeView.name === CreateTestSuiteFormViewName.AddTeams ? (
        <LoadingButton
          data-testid="test-suite-form-save-button"
          disabled={activeView.isPrimaryButtonDisabled}
          loading={isSaving}
          {...(shouldShowWarning
            ? {
                onClick: handleNext
              }
            : {
                type: 'submit'
              })}
          {...(!activeView.isPrimaryButtonDisabled &&
            shouldShowWarning && {
              startIcon: <Icon icon="solidFloppyDisk" />
            })}
          variant="contained"
        >
          {activeView.primaryButtonText}
        </LoadingButton>
      ) : (
        <Button
          data-testid="test-suite-form-next-button"
          disabled={activeView.isPrimaryButtonDisabled}
          variant="contained"
          onClick={handleNext}
          {...(activeView.primaryEndIcon
            ? { endIcon: activeView.primaryEndIcon }
            : {})}
        >
          {activeView.primaryButtonText}
        </Button>
      )}
    </Stack>
  )
}
